import React, { FC } from "react";
import { withRouter, useRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import Head from "next/head";

import Footer from "../src/components/Footer/Footer";
import Profile from "../src/pages/Profile/Profile";
import { createTheme } from '@mui/material/styles';

import withAuthHandler from "../src/components/Auth/WithAuthHandler/WithAuthHandler";
import { NavigationBar } from "../src/components";
import { ThemeProvider } from "@emotion/react";
import { useColorModeContext } from "../src/contexts/CustomThemeProvider";

interface ProfilePageProps extends WithRouterProps {
}

const ProfilePage: FC<ProfilePageProps> = () => {
  const seoTitle = `Profile | That's The Ticket`;

  const { setColorMode } = useColorModeContext();
  setColorMode("dark")

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
    },
  });
  
  return (
    <>
      <Head>
        <title>{`${seoTitle}`}</title>
        <meta key="ogTitle" property="og:title" content={seoTitle} />
        <meta key="twitterTitle" name="twitter:title" content={seoTitle} />
      </Head>
      <NavigationBar showMenu={true} />

      <ThemeProvider theme={darkTheme}>
        <Profile />
      </ThemeProvider>

      <Footer />
    </>
  );
};

export default withAuthHandler(withRouter(ProfilePage));
